import { SectionTitle } from 'components/Section';
import VideoCard from 'components/VideoCard';

type Props = {
    video: Video;
};

export const VideoBlock = ({ video }: Props) => {
    return (
        <>
            <SectionTitle level={2} title="Wideo" url={`/wideo`} />
            <VideoCard video={video} />
        </>
    );
};

export default VideoBlock;
